export default "__VITE_ASSET__BfKvrudj__"